<template>
  <div class="dialogDetail">
    <div class="con">
      <div class="con-1">
        <p class="p"><i>课件标题：</i><span>{{detailInfo.title}}</span></p>
        <p class="p"><i>课程目录：</i><span>{{detailInfo.directoryName}}</span></p>
      </div>
      <div class="con-1">
        <p class="p"><i>关键字：</i><span>{{detailInfo.keys}}</span></p>
        <p class="p"><i>适合专业：</i><span>{{detailInfo.professionName}}</span></p>
      </div>
    </div>
    <iframeFile ref="iframeFile" />
  </div>
</template>

<script>
import { coursewareServer } from '@/api/api'
import iframeFile from '@/components/Iframe';
export default {
  components: {iframeFile},
  data () {
    return {
      detailInfo: {}
    }
  },
  methods: {
    getDetail (id) {
      this.detailInfo = {}
      coursewareServer.coursewareDetail({
        id
      }).then(res => {
        const {code, data, message} = res
        if (code === '0') {
          this.detailInfo = data
          this.getfileurl(data.filePath)
        } else {
          this.$message.error(message)
        }
      }).catch((error) => {
        this.$message.error(error)
      })
    },
    getfileurl (fileKeys) {
      this.$getUrl({
      fileKeys
      }).then(obj => {
        if (obj) {
         this.$refs.iframeFile.open(obj[fileKeys])
        }
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.dialogDetail {
  height: 100%;
}
.con {
  background: #f5f6fa;
  margin-bottom: 20px;
  padding: 20px;
  text-align: left;
  line-height: 28px;
  color: rgba(0, 0, 0, 0.9);
  font-size: 15px;
  .h1{
    color: #333;
    font-size: 15px;
    margin-bottom: 10px;
  }
  p {
    img {
      width: 30px;
      height: 30px;
    }
  }
  .con-1, .con-2{
    display: flex;
    justify-content: space-between;
    p {
      display: inline-block;
      width: 50%;
    }
  }
  .p{
    display: flex;
    justify-content: start;
    i{
      display: inline-block;
    }
    span{
      display: inline-block;
    }
  }
  .long{
    position: relative;
    padding-left: 78px;
    min-height: 22px;
    i{
      position: absolute;
      left: 0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/resource/details/coursewaredetail.vue